import React from "react";
import { useHistory } from "react-router-dom";

import NotifyHintModal from "../../../templates/teacher/NotifyHintModal";
import {
  Context,
  fetchTeachingHintsIntroductions,
  guidelinePath,
} from "../../../teacherStore";
import { parseQueryParams } from "../../../libs/Util";

type Props = {
  onClose: () => void;
};

const NotifyHintModalPage: React.FC<Props> = ({ onClose }) => {
  const notify_hint_type = "interests";
  const { state, dispatch } = React.useContext(Context);
  const history = useHistory();
  const classListInParams = parseQueryParams()["classList"];
  const classList = React.useMemo(
    () =>
      classListInParams
        ? classListInParams.split(",").map((classID: string) => Number(classID))
        : null,
    [classListInParams],
  );

  const targetTeachingMaterial = state.teaching_materials.find(tm =>
    tm.lessons?.some(
      lesson =>
        lesson.id === state.notification_teaching_hint_introduction_lesson_id,
    ),
  );
  const targetLesson = targetTeachingMaterial?.lessons?.find(
    lesson =>
      lesson.id === state.notification_teaching_hint_introduction_lesson_id,
  );

  const targetHint = state.teaching_hint_introduction?.hints.find(
    hint => hint.hint_type === notify_hint_type,
  );

  React.useEffect(() => {
    const lessonId = state.notification_teaching_hint_introduction_lesson_id;
    if (lessonId) {
      dispatch(fetchTeachingHintsIntroductions(lessonId, notify_hint_type));
    }
  }, [dispatch, state.notification_teaching_hint_introduction_lesson_id]);

  const navigateToHintIntroduction = () => {
    if (targetTeachingMaterial && targetLesson) {
      history.push(
        `${guidelinePath}/${targetTeachingMaterial.id}?lesson=${state.notification_teaching_hint_introduction_lesson_id}&page=1&classList=${classList}`,
      );
    }
  };

  /* teaching_materialsフェッチ終了前にレンダーされるのを防止 */
  return targetTeachingMaterial && targetLesson && targetHint ? (
    <NotifyHintModal
      targetLessonTitle={`${targetTeachingMaterial.name} ${targetLesson.name} ${targetLesson.title}`}
      targetHint={targetHint}
      onButtonClick={navigateToHintIntroduction}
      onClose={onClose}
    />
  ) : null;
};

export default NotifyHintModalPage;
